//Query Params
export const PARAM_RETURNURL = 'returnurl'
export const PARAM_MANUFACTURING_TYPE_ID = 'manufacturingTypeId'
export const PARAM_TYPE = 'type'
export const PARAM_SUPPLIER_ID = 'supplierId'
export const PARAM_LOCATION_ID = 'locationId'
export const PARAM_ACTIVE_COMMENTS_TAB = 'activeCommentsTab'
export const PARAM_ACTIVE_TAB = 'activeTab'

//RFI Type values
export const RFI_TYPE_SUPPLIER = 'supplier'
export const RFI_TYPE_LOCATION = 'location'
export const RFI_TYPE_QUESTIONNAIRE = 'questionnaire'
export const CODE_RFI_TYPE_SUPPLIER = 'rfi1'
export const CODE_RFI_TYPE_LOCATION = 'rfi2'
export const CODE_RFI_TYPE_QUESTIONNAIRE = 'rfi3'

//Manufacturing type ID's
export const MANUFACTURING_TYPE_ID_FINISHED_GOOD = '8'
export const MANUFACTURING_TYPE_ID_FABRIC = '7'
export const MANUFACTURING_TYPE_ID_TRIM = '10'
export const MANUFACTURING_TYPE_ID_PACKAGING = '27'
export const MANUFACTURING_TYPE_ID_RAWMATERIAL = '31'
export const MANUFACTURING_TYPE_ID_SECONDARY_PROCESSING = '81'

//Generic values
export const VIEW_SUPPLIER = 'Supplier'
export const TARGET = 'target'
export const VALUE_OTHERS = 'others'
export const VALUE_OTHER = 'other'
export const COMMENTS = 'comments'
export const MESSAGE_VALIDATION_FAILED = 'validation failed'
export const FEEDBACK_EMAIL_ID = 'MVS-Feedback@target.com'
export const DATA_TYPE_OBJECT = 'object'
export const CAPABILITIES = 'Capabilities'
export const SERVICE_CAPABILITIES = 'Service Capabilities'
export const BUTTON = 'button'
export const FACTORY_REGISTRATION_LICENSE = 'factory registration license'
export const FACTORY_REGISTRATION_LICENSE_UID = 'factory_registration_license'
export const TRIM_SUPPLIER_QUALIFICATION_PROGRAM =
  'trim supplier qualification program'
export const DIMENSIONS = 'dimensions'
export const PLACEHOLDER_YYYY_MM_DD = 'YYYY/MM/DD'
export const PAGE_NUMBER = 'PAGE_NUMBER'
export const PAGE_SIZE = 'PAGE_SIZE'
export const SORT_DIRECTION = 'SORT_DIRECTION'
export const SORT_BY = 'SORT_BY'
export const SEARCH_QUERY = 'SEARCH_QUERY'
export const STATUS_CODE = 'STATUS_CODE'
export const SUPPLIER_TYPE = 'SUPPLIER_TYPE'
export const MANUFACTURING_TYPE_ID = 'MANUFACTURING_TYPE_ID'
export const RFI_TYPE = 'RFI_TYPE'
export const RFI3_STATUS_CODE = 'RFI3_STATUS_CODE'
export const CTV_SOURCING_OFFICE = 'CTV_SOURCING_OFFICE'
export const CTP_PSQA_OFFICE = 'CTP_PSQA_OFFICE'
export const CTP_SOURCING_OFFICE = 'CTP_SOURCING_OFFICE'
export const RFI_LAST_MODIFIED_DATE = 'rfi_last_modified_date'
export const SORT_ASCENDING = 'asc'
export const SORT_DESCENDING = 'desc'
export const LOCATION_NAME = 'locationName'
export const SUPPLIER_NAME = 'supplierName'
export const APPAREL_AND_ACCESSORIES = 'APPAREL AND ACCESSORIES'
export const HOME_AND_HARDLINES = 'HOME AND HARDLINES'
export const ESSENTIALS_AND_BEAUTY = 'ESSENTIALS AND BEAUTY'
export const FLORAL = 'FLORAL'
export const GROCERY = 'GROCERY'

//RFI Status
export const STATUS_APPROVED = 'approved'
export const STATUS_REJECTED = 'rejected'
export const STATUS_SENT_BACK = 'sent back'
export const STATUS_COMPLETE_REVIEW = 'complete review'
export const STATUS_REVIEW_COMPLETED = 'review completed'
export const STATUS_INITIATED = 'initiated'
export const STATUS_FASTTRACKED = 'fasttracked'
export const STATUS_STARTED = 'started'
export const STATUS_SUBMITTED = 'submitted'
export const STATUS_RFI3_APPROVED = 'RFI3 APPROVED'
export const LABEL_RFI3_APPROVED = 'RFI3 Approved'
export const STATUS_SYSTEM_APPROVED = 'system approved'
export const STATUS_AUTO_APPROVED = 'auto approved'
export const STATUS_APPROVE_BUT_HOLD = 'approve but hold'
export const BUTTON_APPROVE = 'Approve'
export const BUTTON_APPROVE_BUT_HOLD = 'Approve but Hold'
export const STATUS_APPROVE_AND_START_VFA = 'approve & start vfa'
export const BUTTON_APPROVE_AND_START_VFA = 'Approve & Start VFA'
export const STATUS_APPROVE_AND_BYPASS_VFA = 'approve & bypass vfa'
export const BUTTON_APPROVE_AND_BYPASS_VFA = 'Approve & bypass VFA'
export const APPROVE_GROUP = 'approve group'
export const STATUS_LIST_WITHOUT_COMMENTS = [
  'APPROVED',
  STATUS_APPROVE_AND_START_VFA.toUpperCase(),
  STATUS_COMPLETE_REVIEW.toUpperCase(),
]

//Control types
export const CONTROL_TYPE_FILEUPLOAD = 'fileupload'
export const CONTROL_TYPE_FILEDOWNLOAD = 'filedownload'
export const CONTROL_TYPE_MULTI_AUTOCOMPLETE = 'multi_autocomplete'
export const CONTROL_TYPE_MULTI_AUTOCOMPLETE_OTHERS =
  'multi_autocomplete_others'
export const CONTROL_TYPE_MULTI_AUTOCOMPLETE_HIERARCHY =
  'multi_autocomplete_hierarchy'
export const CONTROL_COMPOSITE_UNIT = 'inside_row_repeater'
export const CONTROL_TYPE_STRENGTH_ASSESSMENT = 'strength_assessment'
export const CONTROL_PHONE_NUMBER_FIELD_PHONE = 'phone'
export const CONTROL_LABEL_READONLY_BANNER = 'label_readonly_banner'
export const LOCATION_ARCHIVED_BANNER = 'location_archived_banner'
export const NON_COMPLIANT_BANNER = 'non_compliant_banner'
export const INTERNAL_TESTING_METHODS_SECTION_UID = 'internal_testing_methods'

//Messages
export const MESSAGE_TRIM_CAPABILITIES_ADDED =
  'More trim capabilities added below'
export const MESSAGE_HEADER_SUBMIT_FAIL = 'Submission Failed'
export const SUPPLIER_RFI_NOT_APPROVED = `Until the supplier's RFI 1 is approved, no action can be taken on the RFI 2.`
export const SUPPLIER_RFI_REJECTED = "Supplier's RFI 1 is rejected"
export const SUPPLIER_RFI_REJECTED_FOR_RFI2 =
  "The supplier's RFI 1 is rejected, so no action can be taken on the RFI 2."
export const SUPPLIER_RFI_APPROVED = "Supplier's RFI 1 is approved"
export const SUPPLIER_RFI_SENT_BACK = "Supplier's RFI 1 has been sent back"
export const LOCATION_RFI_APPROVED = "Location's RFI 2 is approved"
export const LOCATION_RFI_REJECTED = "Location's RFI 2 is rejected"
export const LOCATION_RFI_SENT_BACK = "Location's RFI 2 has been sent back"
export const CHATBOT_RETRY_LIMIT = 5
export const ENABLE_APPROVE_TOOLTIP =
  'Please respond to all the RFI3 questions to activate the Approve button. Alternatively, you may click on Fast Track (if RFI3 is not required) to activate the Approve button.'
export const ENABLE_REJECT_TOOLTIP =
  'Please respond to all the RFI3 questions to activate the Reject button. Alternatively, you may click on Fast Track (if RFI3 is not required) to activate the Reject button.'
export const FASTTRACK_TOOLTIP =
  'Click here if RFI3 is not required to be done at this point of time.'
export const MSG_VALIDATION_ERROR =
  'Validation error(s) in Tab(s) : <strong><TABS></strong>. Please update to submit.'

//RFI3 Question type
export const QUESTION_TYPE_UPLOAD = 'fileupload'
export const QUESTION_TYPE_TEXTAREA = 'textarea'
export const QUESTION_TYPE_TEXTBOX = 'textbox'
export const QUESTION_TYPE_PERCENTAGEBOX = 'percentage_box'
export const SECTION_INLINE_HEADER = 'section_inline_header'
export const SUB_SECTION_INLINE_HEADER = 'sub_section_inline_header'

export const CONDITION_DEFAULT = 'default'
export const AUDIENCE_INTERNAL = 'internal'

//Capabilities Popup
export const POPUP_HEADER_CAPABILITIES_EDITABLE = 'Check Capabilities'
export const POPUP_HEADER_CAPABILITIES_READONLY = 'Approved Capabilities'
export const MSG_APPROVE_CAPABILITIES =
  'Please select the Capabilities you want to approve.'
export const MSG_CAPABALITIES_APPROVED = 'Check which capabilities are approved'
export const ENABLE_NEXT_BUTTON_TOOLTIP =
  'Please select a capability and add comments to proceed with approval'

//Routes
export const ROUTE_VETTING_SUMMARY_LOCATION =
  '/internal/vetting_summary?type=location'
export const ROUTE_VETTING_SUMMARY_SUPPLIER =
  '/internal/vetting_summary?type=supplier'

//Settings
export const COMMENTS_MAX_LENGTH = 500
export const DEFAULT_WIDTH_PERCENT = 90
export const TRANSITION_TIME_PIXEL = 0.01

//Fields
export const FIELD_COUNTRY = 'country'
export const CLIENT_TRIM_PRODUCTS = 'trim_products'

//Finished Good
export const FINISHED_GOOD_PRODUCT_TYPE = 'product_type'
export const FINISHED_GOOD_PRODUCT_SUB_TYPE = 'product_sub_type'
export const FINISHED_GOOD_ITEM_TYPE = 'item_type'

//Trim
export const FIELD_TRIM_TYPE = 'primary_trim_type'
export const FIELD_TRIM_SUB_TYPE = 'trim_sub_type'
export const FIELD_TRIM_MATERIAL_TYPE = 'material_type'
export const FIELD_TRIM_MATERIAL_CONTENT = 'material_content'
export const FIELD_TRIM_BASE_MATERIAL = 'base_material'
export const FIELD_TRIM_CONSTRUCTIONS = 'construction'
export const FIELD_TRIM_PRIMARY_UOM = 'unit_of_measurements'

//Fabric
export const FIELD_FABRIC_PRIMARY_TYPE = 'primary_fabric_type'
export const FIELD_FABRIC_STRENGTH_ASSESSMENT = 'strength_assessment'
export const FIELD_TRIM_LIST_PRODUCT_SPECIFICATION = 'product_specifications'

//capabilities name
export const CAPABILITY_NAME = 'capabilityName'
export const PROCESS_NAME = 'processName'
export const SERVICE_NAME = 'serviceName'

//Admin control
export const ADMIN_CONTROL_TYPE = 'control'
export const ADMIN_ID_RFI2_ACTION_BUTTONS = 'rfi3ActionButtons'
export const ADMIN_ID_CHATBOT_LCM = 'chatbotLCM'
//Packaging
export const FIELD_SUPPLIER_COUNTRY_OF_PRODUCTION =
  'supplier_country_of_production'
export const FIELD_SUPPLIER_REGION_OF_PRODUCTION =
  'supplier_region_of_production'
export const FIELD_SUBSTRATE_TYPE = 'substrate_type'
export const FIELD_SUBSTRATE_SUB_TYPE = 'substrate_sub_type'
export const FIELD_CERTIFIED_FOR = 'certified_for'

//Mapper Keys
export const KEY_CAPABILITY_ROW_DISPLAY_ITEM = 'capabilityRowDisplayItems'
export const KEY_SERVICE_ROW_DISPLAY_ITEM = 'serviceRowDisplayItems'

//Firefly Event Names for RFI Timelines
export const FIRST_APPROVED = 'First Approved'
export const FIRST_SUBMITTED = 'First Submitted'
export const FIRST_INITIATED = 'First Initiated'
export const TEXT_APPROVE = 'approve'
export const TIMELINE_VIEW_NAME = 'RFI Timelines'

//Dynamic Table Section - Excluded Control Types
export const EXCLUDED_TABLE_CONTROL_TYPES = [
  'SECTION_INLINE_HEADER',
  'SUB_SECTION_INLINE_HEADER',
  'COLUMN_SPACE',
  'LINE_SPACE',
]
